(function () {
  var SETTINGS = {
    sequinInStock: 7,
    sequinSpecialOrder: 13,
    patchwork: 15,
    pufferVest: 15,
    pufferJacket: 15
  };

  function getVariantIdFromUrl() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  function getSelectedVariantId() {
    var urlVariant = getVariantIdFromUrl();
    if (urlVariant && window.variantShipData && window.variantShipData[urlVariant]) return urlVariant;

    var select = document.querySelector('select[name="id"]');
    return select && select.value ? select.value : null;
  }

  function getProductGroup() {
    var data = window.productionProductData || {};
    var text = ((data.type || '') + ' ' + (data.tags || '') + ' ' + (data.title || '')).toLowerCase();

    if (text.indexOf('puffer jacket') !== -1) return 'puffer-jacket';
if (text.indexOf('puffer vest') !== -1) return 'puffer-vest';
if (text.indexOf('patchwork') !== -1) return 'patchwork';
if (text.indexOf('3-week-production') !== -1) return 'patchwork';
if (text.indexOf('2-5-week-production') !== -1) return '2-5-week';
if (text.indexOf('portrait') !== -1) return 'patchwork';
if (text.indexOf('sequin') !== -1) return 'sequin';

    return 'default';
  }

  function nthWeekdayOfMonth(year, month, weekday, nth) {
    var date = new Date(year, month, 1);
    var count = 0;

    while (date.getMonth() === month) {
      if (date.getDay() === weekday) {
        count++;
        if (count === nth) return new Date(date);
      }
      date.setDate(date.getDate() + 1);
    }
  }

  function lastWeekdayOfMonth(year, month, weekday) {
    var date = new Date(year, month + 1, 0);
    while (date.getDay() !== weekday) date.setDate(date.getDate() - 1);
    return date;
  }

  function observedDate(year, month, day) {
    var date = new Date(year, month, day);
    if (date.getDay() === 6) date.setDate(date.getDate() - 1);
    if (date.getDay() === 0) date.setDate(date.getDate() + 1);
    return date;
  }

  function formatDateKey(date) {
    return date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate();
  }

  function getUSHolidays(year) {
    return [
      observedDate(year, 0, 1),
      nthWeekdayOfMonth(year, 0, 1, 3),
      nthWeekdayOfMonth(year, 1, 1, 3),
      lastWeekdayOfMonth(year, 4, 1),
      observedDate(year, 5, 19),
      observedDate(year, 6, 4),
      nthWeekdayOfMonth(year, 8, 1, 1),
      nthWeekdayOfMonth(year, 9, 1, 2),
      observedDate(year, 10, 11),
      nthWeekdayOfMonth(year, 10, 4, 4),
      observedDate(year, 11, 25)
    ].map(formatDateKey);
  }

  function isBusinessDay(date) {
    var day = date.getDay();
    if (day === 0 || day === 6) return false;

    return getUSHolidays(date.getFullYear()).indexOf(formatDateKey(date)) === -1;
  }

  function addBusinessDays(days) {
    var date = new Date();
    var added = 0;

    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (isBusinessDay(date)) added++;
    }

    return date;
  }

  function formatDisplayDate(date) {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  }

  function productionLabel(days) {
    if (days === 7) return '7 business days';
    if (days === 13) return 'Approximately 2½ business weeks';
    if (days === 15) return '3 business weeks';
    return days + ' business days';
  }

  function statusDetails(days) {
  return (
    '<div class="production-details">' +
      '<div class="info-row">' +
        '<div class="info-label">Production Time</div>' +
        '<div class="info-value">' + productionLabel(days) + '</div>' +
      '</div>' +
      '<div class="info-row">' +
        '<div class="info-label expected-label">Expected to Ship</div>' +
        '<div class="info-value ship-date">' + formatDisplayDate(addBusinessDays(days)) + '</div>' +
      '</div>' +
    '</div>' +
    '<div class="delivery-note">Production schedules update automatically based on your selected color and size. Estimated delivery will be calculated at checkout based on your shipping address and selected shipping method.</div>'
  );
}

  function updateProductionStatus() {
    var box = document.getElementById('variant-ship-message');
    if (!box || !window.variantShipData) return;

    var variantId = getSelectedVariantId();
    var variantData = window.variantShipData[variantId];
    if (!variantData) return;

    var group = getProductGroup();
    var inventory = variantData.inventory_quantity;

    box.classList.add('updating');
box.innerHTML =
  '<div class="production-title">Production Status</div>' +
  '<strong>Updating production schedule...</strong>';

    setTimeout(function () {
      if (group === 'sequin') {
        if (inventory > 0) {
          box.className = 'variant-ship-message ready';
          box.innerHTML =
            '<div class="production-title">Production & Shipping</div>' +
            '<div class="production-status">🟢 Ready to Customize</div>' +
            'Your selected color and size is in stock and ready to be customized.<br>' +
            statusDetails(SETTINGS.sequinInStock);

            updateOrderProperties(
  SETTINGS.sequinInStock,
  'Ready to Customize'
);
        } else {
          box.className = 'variant-ship-message special-order';
          box.innerHTML =
            '<div class="production-title">Production & Shipping</div>' +
            '<div class="production-status">🟠 Special Order Required</div>' +
            'Your selected color and size will be ordered from our manufacturer before it is customized.<br>' +
            statusDetails(SETTINGS.sequinSpecialOrder);

            updateOrderProperties(
  SETTINGS.sequinSpecialOrder,
  'Special Order Required'
);
        }
      } else if (group === 'patchwork' || group === 'puffer-vest') {
        var days = group === 'patchwork' ? SETTINGS.patchwork : SETTINGS.pufferVest;

        box.className = 'variant-ship-message special-order';
        box.innerHTML =
          '<div class="production-title">Production & Shipping</div>' +
          '<div class="production-status">✨ Made to Order</div>' +
          'This item is custom made after purchase.<br>' +
          statusDetails(days);

          updateOrderProperties(
  days,
  'Made to Order'
);
          } else if (group === '2-5-week') {
  box.className = 'variant-ship-message special-order';
  box.innerHTML =
    '<div class="production-title">Production & Shipping</div>' +
    '<div class="production-status">✨ Made to Order</div>' +
    'This item is custom made after purchase.<br>' +
    statusDetails(SETTINGS.sequinSpecialOrder);

    updateOrderProperties(
  SETTINGS.sequinSpecialOrder,
  'Made to Order'
);
      } else if (group === 'puffer-jacket') {
        if (inventory > 0) {
          box.className = 'variant-ship-message ready';
          box.innerHTML =
            '<div class="production-title">Production & Shipping</div>' +
            '<div class="production-status">🟢 Limited Stock Available</div>' +
            'This item is available while supplies last and will not be restocked once sold out.<br>' +
            statusDetails(SETTINGS.pufferJacket);

            updateOrderProperties(
  SETTINGS.pufferJacket,
  'Limited Stock Available'
);
        } else {
          clearOrderProperties();
          box.className = 'variant-ship-message out-of-stock';
          box.innerHTML =
            '<div class="production-title">Production & Shipping</div>' +
            '<strong>Sold Out</strong><br>' +
            'This item is limited stock and will not be restocked.';
        }
      } else {
        clearOrderProperties();
        box.style.display = 'none';
        return;
      }

      box.style.display = 'block';

      setTimeout(function () {
        box.classList.remove('updating');
      }, 50);
    }, 150);
  }
function updateOrderProperties(days, status) {
    var productForm = document.getElementById('AddToCartForm');

  if (!productForm) return;

  function setProperty(name, value) {
    var input = productForm.querySelector(
      'input[name="properties[' + name + ']"]'
    );

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      productForm.appendChild(input);
    }

    input.value = value;
  }

  setProperty('Production Status', status);
  setProperty('Production Time', productionLabel(days));
  setProperty('Expected Ship Date', formatDisplayDate(addBusinessDays(days)));
}

function clearOrderProperties() {
  var productForm = document.getElementById('AddToCartForm');
  if (!productForm) return;

  [
    'Production Status',
    'Production Time',
    'Expected Ship Date'
  ].forEach(function (name) {
    var input = productForm.querySelector(
      'input[name="properties[' + name + ']"]'
    );

    if (input) input.remove();
  });
}

  document.addEventListener('DOMContentLoaded', function () {
    updateProductionStatus();

    document.addEventListener('change', function () {
      setTimeout(updateProductionStatus, 100);
      setTimeout(updateProductionStatus, 400);
    });

    document.addEventListener('click', function () {
      setTimeout(updateProductionStatus, 150);
      setTimeout(updateProductionStatus, 500);
    });

    var lastVariantId = getSelectedVariantId();

    setInterval(function () {
      var currentVariantId = getSelectedVariantId();

      if (currentVariantId !== lastVariantId) {
        lastVariantId = currentVariantId;
        updateProductionStatus();
      }
    }, 250);
  });
})();